import {
  GET_SUGGESTIONS,
  CLEAR_SUGGESTIONS,
  SET_SEARCH_INPUT_VALUE
} from "../actions/search";

function search(state = { suggestions: [], inputValue: "" }, action) {
  switch (action.type) {
    case GET_SUGGESTIONS:
      return Object.assign({}, state, {
        suggestions: action.suggestions
      });
    case CLEAR_SUGGESTIONS:
      return Object.assign({}, state, {
        suggestions: []
      });
    case SET_SEARCH_INPUT_VALUE:
      return Object.assign({}, state, {
        inputValue: action.value
      });
    default:
      return state;
  }
}

export default search;



// WEBPACK FOOTER //
// ./src/reducers/search.js